<template>
    <v-col style="flex: 0 0 20%; max-width: 20%;">
        <div v-ripple class="helpical-cards user-select-none pa-4 h-100">
            <v-skeleton-loader v-if="ticketSkeleton" class="mx-auto" height="60" max-width="100%" type="ossein"></v-skeleton-loader>
            <div class="d-flex ga-2 cursor-pointer ma-0" v-else @click="$router.push({ path: '/tickets', query: { 'ticket_statuses': ['0'] } })">
                <div class="d-md-block d-none">
                    <i class="icon icon-new icon-3x"><span class="path1 icon"></span><span class="path2 icon"></span><span class="path3 icon"></span><span class="path4 icon"></span><span class="path5 icon"></span></i>
                </div>
                <div class="flex-fill">
                    <h3 class="mb-1 font-weight-bold text-grey-darken-2 text-md-start text-center">{{ ticketStatuses['0'] }}</h3>
                    <p class="mb-0 text-small font-weight-medium text-grey text-md-start text-center">تیکت‌ باز</p>
                </div>
            </div>
        </div>
    </v-col>
    <v-col style="flex: 0 0 20%; max-width: 20%;">
        <div v-ripple class="helpical-cards user-select-none pa-4 h-100">
            <v-skeleton-loader v-if="ticketSkeleton" class="mx-auto" height="60" max-width="100%" type="ossein"></v-skeleton-loader>
            <div class="d-flex ga-2 cursor-pointer ma-0" v-else @click="$router.push({ path: '/tickets', query: { 'ticket_statuses': ['2'] } })">
                <div class="d-md-block d-none">
                    <i class="icon icon-3x icon-karmand"><span class="icon path1"></span><span class="icon path2"></span></i>
                </div>
                <div class="flex-fill">
                    <h3 class="mb-1 font-weight-bold text-grey-darken-2 text-md-start text-center">{{ ticketStatuses['2'] }}</h3>
                    <p class="mb-0 text-small font-weight-medium text-grey text-md-start text-center">تیکت‌ پاسخ کارشناس</p>
                </div>
            </div>
        </div>
    </v-col>
    <v-col style="flex: 0 0 20%; max-width: 20%;">
        <div v-ripple class="helpical-cards user-select-none pa-4 h-100">
            <v-skeleton-loader v-if="ticketSkeleton" class="mx-auto" height="60" max-width="100%" type="ossein"></v-skeleton-loader>
            <div class="d-flex ga-2 cursor-pointer ma-0" v-else @click="$router.push({ path: '/tickets', query: { 'ticket_statuses': ['3'] } })">
                <div class="d-md-block d-none">
                    <i class="icon icon-moshtari icon-3x"><span class="icon path1"></span><span class="icon path2"></span></i>
                </div>
                <div class="flex-fill">
                    <h3 class="mb-1 font-weight-bold text-grey-darken-2 text-md-start text-center">{{ ticketStatuses['3'] }}</h3>
                    <p class="mb-0 text-small font-weight-medium text-grey text-md-start text-center">تیکت‌ پاسخ مشتری</p>
                </div>
            </div>
        </div>
    </v-col>
    <v-col style="flex: 0 0 20%; max-width: 20%;">
        <div v-ripple class="helpical-cards user-select-none pa-4 h-100">
            <v-skeleton-loader v-if="ticketSkeleton" class="mx-auto" height="60" max-width="100%" type="ossein"></v-skeleton-loader>
            <div class="d-flex ga-2 cursor-pointer ma-0" v-else @click="$router.push({ path: '/tickets', query: { 'ticket_statuses': ['1'] } })">
                <div class="d-md-block d-none">
                    <i class="icon icon-pending icon-3x"><span class="path1 icon"></span><span
                            class="path2 icon"></span><span class="path3 icon"></span></i>
                </div>
                <div class="flex-fill">
                    <h3 class="mb-1 font-weight-bold text-grey-darken-2 text-md-start text-center">{{ ticketStatuses['1'] }}</h3>
                    <p class="mb-0 text-small font-weight-medium text-grey text-md-start text-center">تیکت‌ در حال انجام</p>
                </div>
            </div>
        </div>
    </v-col>
    <v-col style="flex: 0 0 20%; max-width: 20%;">
        <div v-ripple class="helpical-cards user-select-none pa-4 h-100">
            <v-skeleton-loader v-if="ticketSkeleton" class="mx-auto" height="60" max-width="100%" type="ossein"></v-skeleton-loader>
            <div class="d-flex ga-2 cursor-pointer ma-0" v-else @click="$router.push({ path: '/tickets', query: { 'ticket_statuses': ['4'] } })">
                <div class="d-md-block d-none">
                    <i class="icon icon-done icon-3x"><span class="path1 icon"></span><span class="path2 icon"></span><span class="path3 icon"></span><span class="path4 icon"></span><span class="path5 icon"></span></i>
                </div>
                <div class="flex-fill">
                    <h3 class="mb-1 font-weight-bold text-grey-darken-2 text-md-start text-center">{{ ticketStatuses['4'] }}</h3>
                    <p class="mb-0 text-small font-weight-medium text-grey text-md-start text-center">تیکت‌ بسته شده</p>
                </div>
            </div>
        </div>
    </v-col>
</template>
<script setup>
const ticketSkeleton = ref(true);
const ticketStatuses = reactive({
    '0': 0,
    '1': 0,
    '2': 0,
    '3': 0,
    '4': 0,
});
const api = useApi();
function getReportTicketStatusTicket() {
    api.reportTicketStatusTicket().then((res) => {
        if (res && res.status == "OK")
            res.data.forEach((el) => {
                ticketStatuses[el.x] = el.total;
            });
        ticketSkeleton.value = false;
    });
}
getReportTicketStatusTicket();
</script>
